import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'

import icons from '../../icons'

const AddIcon = icons.add
const RemoveIcon = icons.remove

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
  }
}))

interface NumericClickerProps {
  title?: string,
  increaseTitle?: string,
  decreaseTitle?: string,
  onChange: {
    (amount: number): void,
  },
}

const NumericClicker: FC<React.PropsWithChildren<NumericClickerProps>> = ({
  title,
  increaseTitle = 'increase',
  decreaseTitle = 'decrease',
  onChange,
}) => {

  const classes = useStyles()
 
  return (
    <div className={ classes.root }>
      {
        title && (
          <Typography color="primary" variant="caption">{ title }</Typography>
        )
      }
      <Tooltip title={ decreaseTitle }>
        <IconButton
          size="small"
          className={ classes.button }
          onClick={ (e) => {
            e.preventDefault()
            e.stopPropagation()
            onChange(-1)
          }}
        >
          <RemoveIcon color="primary" />
        </IconButton>
      </Tooltip>
      <Tooltip title={ increaseTitle }>
        <IconButton
          size="small"
          className={ classes.button }
          onClick={ (e) => {
            e.preventDefault()
            e.stopPropagation()
            onChange(1)
          }}
        >
          <AddIcon color="primary" />
        </IconButton>
      </Tooltip>
    </div>
  )

}

export default NumericClicker